import React from 'react';
import { FormattedMessage } from 'react-intl';

/**
 * Builds the helper-text content for a field, or `undefined` when there is
 * nothing to say.
 *
 * A function, not a component, on purpose: MUI decides whether to render the
 * helper slot by testing `helperText` for truthiness, and a JSX element is
 * truthy even when it renders null — so a component could never stop the empty
 * `<p>` from being emitted. The decision has to be made before the element
 * exists, which is what a function lets a call site do.
 *
 * `error` is a validation-message key — 'required', 'invalid_email_address', …
 * from `@/components/Form/validation` — resolved as `message.<key>` with spaces
 * folded to underscores. A string that is not a known key falls through to
 * defaultMessage and renders as-is, which is how backend-supplied messages get
 * displayed.
 */
const helperTextError = (error?: string | null) =>
  error ? <FormattedMessage id={`message.${error.split(' ').join('_')}`} defaultMessage={error} /> : undefined;

export default helperTextError;
